import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { getNotic } from '../Store/ActionCreators/NotifactionActionCreator';
import Navbar from '../User/Navbar';
import Footer from '../User/Footer';

export default function Important() {
  const Notifactionlist = useSelector((state)=>state.NoticStateData)
  const important = Notifactionlist.filter(item => item.category === "Important");
  const dispatch = useDispatch()
  useEffect(()=>{
    dispatch(getNotic())
  })
  return (
    <>
    <Navbar/>
      <div className="container">
        <div className="card cardItem mt-5">
        <h6 className="title bg-danger text-white p-2 text-center">Important</h6>
        {important.length > 0 ? important.map((n, i) => (
        <p key={i} style={{fontWeight:"bold"}}>
        <Link to={`/notifactionview/${n._id}`} target="_blank">{n.titlename}</Link>
        </p>
        )) : <p>No Answer Key Available</p>}
      </div>
      </div>
      <Footer/>
    </>
  )
}
